<template>
  <div
    class="fpui-banner"
    :class="[`fpui-banner-${variant}`, { 'fpui-banner-with-action': withAction, 'fpui-banner-break-words': breakWords }]"
  >
    <span class="fpui-banner-badge">{{ computedBadge }}</span>
    <span class="fpui-banner-text"><slot /></span>
    <span
      v-if="withAction"
      class="fpui-banner-action"
    >
      <slot name="action" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'FpuiBanner',
  props: {
    // info | warn | bad
    variant: { type: String, default: 'info' },
    // Character shown in the round badge; defaults to a sensible glyph per variant.
    badge: { type: String, default: '' },
    // Reserve space (and vertically center) for an action passed through the #action slot.
    withAction: { type: Boolean, default: false },
    // Break inside a run of characters that has no spaces to wrap on (a long
    // identifier in a SQL error, a URL) instead of letting it overflow the
    // banner. Off by default so existing banners keep their line breaking.
    breakWords: { type: Boolean, default: false }
  },
  computed: {
    computedBadge () {
      if (this.badge) return this.badge
      if (this.variant === 'bad') return '✕'
      if (this.variant === 'warn') return '!'
      return 'i'
    }
  }
}
</script>

<style lang="less">
.fpui-banner {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 9px 13px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.45;

  &.fpui-banner-with-action {
    align-items: center;
  }

  .fpui-banner-badge {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    border-radius: 50%;
    color: #FFFFFF;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }
  .fpui-banner-text {
    flex: 1;
  }
  .fpui-banner-action {
    flex: 0 0 auto;
    align-self: center;
    margin-left: 10px;
  }

  &.fpui-banner-break-words {
    .fpui-banner-text {
      // `min-width: 0` is the part that actually does the work: a flex item
      // defaults to `min-width: auto`, so it refuses to shrink below its
      // longest word and overflows the banner rather than wrapping.
      min-width: 0;
      overflow-wrap: anywhere;
    }
  }

  &.fpui-banner-info {
    background: #eaf7fd;
    border-color: #cdebf8;
    color: #0a5b7a;
    .fpui-banner-badge { background: #0089C0; }
  }
  &.fpui-banner-warn {
    background: #fff6e9;
    border-color: #f3d199;
    color: #8a5300;
    .fpui-banner-badge { background: #e8830c; }
  }
  &.fpui-banner-bad {
    background: #fff0f0;
    border-color: #f5c2c2;
    color: #a11;
    .fpui-banner-badge { background: #e03131; }
  }
}
</style>
